import images from "./images";


const cases = [ 
    {
        id: 1,
        image: images.case1,
        title: "Home Surveillance",
        details: {
            date: "March 15, 2024",
            beneficiaries: "Homeowners",
            category: "Residential Security",
            duration: "6 months",
            location: "Nationwide",
            cost: "Affordable Security Plans",
            projectLead: "Sarah Miller"
        },
        paragraphs: [
            "Secure your home with cutting-edge surveillance solutions designed for round-the-clock protection. Our advanced home security systems utilize high-resolution cameras, AI-driven monitoring, and remote access for enhanced safety.",
            "With smart motion detection, real-time alerts, and cloud storage options, homeowners can monitor their property anytime, anywhere. Whether it's preventing break-ins or ensuring family safety, our tailored solutions provide complete peace of mind."
        ],
        gallery: [
            images.case1Gallery1,
            images.case1Gallery2,
            images.case1Gallery3,
            images.case1Gallery4,
            images.case1Gallery5,
            images.case1Gallery6,
        ],
        challenges: [
            "Increasing home burglary rates",
            "Limited visibility and security coverage",
            "High false alarm rates with traditional systems",
            "Lack of remote access and real-time alerts"
        ],
        solutions: [
            "AI-powered motion detection for accurate alerts",
            "360-degree high-resolution camera coverage",
            "Cloud-based recording with encrypted storage",
            "Mobile app integration for remote monitoring"
        ],
        results: [
            "Significant reduction in home intrusion incidents",
            "Enhanced security coverage with smart surveillance",
            "Real-time monitoring for instant response",
            "Increased homeowner confidence and safety"
        ]
    },
    {
        id: 2,
        image: images.case2,
        title: "Retail Surveillance",
        details: {
            date: "May 20, 2024",
            beneficiaries: "Retail Store Owners",
            category: "Commercial Security",
            duration: "4 months",
            location: "Multiple Retail Locations",
            cost: "Custom Surveillance Packages",
            projectLead: "David Johnson"
        },
        paragraphs: [
            "Enhance retail security with our advanced surveillance systems designed to protect businesses from theft, fraud, and unauthorized access. Our smart security solutions offer real-time monitoring, AI-powered analytics, and seamless store integration.",
            "Retailers can now monitor store activity, track suspicious behavior, and reduce inventory shrinkage with intelligent video analytics. With remote access and 24/7 surveillance, businesses can ensure a secure shopping environment for customers and staff."
        ],
        gallery: [
            images.case2Gallery1,
            images.case2Gallery2,
            images.case2Gallery3,
            images.case2Gallery4,
            images.case2Gallery5,
            images.case2Gallery6,
        ],
        challenges: [
            "Increase in shoplifting and internal theft",
            "Difficulty in monitoring multiple store locations",
            "High security costs with traditional systems",
            "Limited real-time incident response"
        ],
        solutions: [
            "AI-powered video analytics to detect suspicious activities",
            "Centralized security monitoring for multiple stores",
            "Cost-effective surveillance with cloud-based storage",
            "Instant alerts and real-time mobile access for store managers"
        ],
        results: [
            "Reduced theft and fraud cases by 40%",
            "Improved staff and customer safety",
            "Enhanced operational efficiency with automated monitoring",
            "Increased business confidence through smart security"
        ]
    },
    {
        id: 3,
        image: images.case3,
        title: "Home Security",
        details: {
            date: "April 15, 2024",
            beneficiaries: "Homeowners",
            category: "Residential Security",
            duration: "3 months",
            location: "Urban & Suburban Areas",
            cost: "Flexible Security Packages",
            projectLead: "Sarah Miller"
        },
        paragraphs: [
            "Our smart home security solutions offer homeowners peace of mind with advanced CCTV surveillance, AI-powered threat detection, and 24/7 monitoring. With seamless integration, users can monitor their homes remotely, ensuring maximum security at all times.",
            "From motion detection to smart door access, our systems provide real-time alerts, reducing the risk of intrusions and unauthorized access. Experience next-generation home protection with a security system designed for modern living."
        ],
        gallery: [
            images.case3Gallery1,
            images.case3Gallery2,
            images.case3Gallery3,
            images.case3Gallery4,
            images.case3Gallery5,
            images.case3Gallery6,
        ],
        challenges: [
            "Increase in home break-ins and security breaches",
            "Lack of real-time monitoring and response",
            "Limited access to home security while away",
            "High costs of traditional security systems"
        ],
        solutions: [
            "AI-powered motion detection and facial recognition",
            "Smart door access control with mobile authentication",
            "Remote monitoring via smartphone and cloud storage",
            "Cost-efficient security packages for all home sizes"
        ],
        results: [
            "Enhanced home safety with 24/7 monitoring",
            "Instant alerts and real-time mobile access",
            "Reduction in unauthorized access incidents",
            "Increased homeowner confidence in security"
        ]
    },
    {
        id: 4,
        image: images.case4,
        title: "Public Surveillance",
        details: {
            date: "May 20, 2024",
            beneficiaries: "Government & Law Enforcement",
            category: "Government Projects",
            duration: "6 months",
            location: "Urban & Public Areas",
            cost: "Custom Government Contracts",
            projectLead: "David Johnson"
        },
        paragraphs: [
            "Our advanced public surveillance systems provide government agencies and law enforcement with real-time monitoring, AI-driven analytics, and high-definition CCTV coverage to enhance city security and ensure public safety.",
            "By deploying strategically placed surveillance cameras, facial recognition, and automated threat detection, we help authorities prevent crime, manage crowds, and respond swiftly to security threats in public spaces."
        ],
        gallery: [
            images.case4Gallery1,
            images.case4Gallery2,
            images.case4Gallery3,
            images.case4Gallery4,
            images.case4Gallery5,
            images.case4Gallery6,
        ],
        challenges: [
            "Rising security threats in public spaces",
            "Limited real-time monitoring and response capabilities",
            "Need for centralized surveillance for law enforcement",
            "High cost of implementing large-scale security networks"
        ],
        solutions: [
            "AI-powered facial recognition and behavior analysis",
            "Integrated control centers for real-time monitoring",
            "Smart traffic and crowd management solutions",
            "Cost-effective deployment with scalable security infrastructure"
        ],
        results: [
            "Improved crime prevention with real-time monitoring",
            "Faster emergency response and threat detection",
            "Enhanced public safety and reduced security risks",
            "Efficient law enforcement collaboration through centralized systems"
        ]
    },
    {
        id: 5,
        image: images.case5,
        title: "Office Security",
        details: {
            date: "June 15, 2024",
            beneficiaries: "Corporate Offices & Business Centers",
            category: "Commercial Security",
            duration: "4 months",
            location: "Corporate Buildings & Offices",
            cost: "Flexible Business Packages",
            projectLead: "Emily Brown"
        },
        paragraphs: [
            "Our office security solutions provide businesses with high-end surveillance, access control, and intrusion detection systems to safeguard employees, assets, and sensitive information.",
            "By integrating smart security technologies such as biometric access, HD CCTV cameras, and real-time alerts, we enhance workplace security, prevent unauthorized access, and ensure a safe and secure environment for employees and visitors."
        ],
        gallery: [
            images.case5Gallery1,
            images.case5Gallery2,
            images.case5Gallery3,
            images.case5Gallery4,
            images.case5Gallery5,
            images.case5Gallery6,
        ],
        challenges: [
            "Unauthorized access and security breaches",
            "Lack of real-time monitoring for office premises",
            "Difficulty in tracking employee and visitor movements",
            "Integration issues with existing security infrastructure"
        ],
        solutions: [
            "Biometric & RFID access control for restricted areas",
            "HD CCTV surveillance with cloud-based storage",
            "Real-time intrusion detection and automated alerts",
            "Seamless integration with existing security systems"
        ],
        results: [
            "Improved office security with controlled access",
            "Enhanced employee safety and asset protection",
            "24/7 monitoring for rapid threat response",
            "Scalable solutions tailored for corporate needs"
        ]
    },
    {
        id: 6,
        image: images.case6,
        title: "City Monitoring",
        details: {
            date: "May 20, 2024",
            beneficiaries: "Municipalities & Law Enforcement",
            category: "Government Projects",
            duration: "6 months",
            location: "Urban & Public Areas",
            cost: "Government-Funded Initiative",
            projectLead: "David Johnson"
        },
        paragraphs: [
            "Our city-wide surveillance solutions are designed to enhance public safety, monitor traffic, and prevent criminal activities using high-definition CCTV cameras and AI-powered analytics.",
            "By integrating smart monitoring technologies, we provide law enforcement with real-time insights, facial recognition, and automated alerts, ensuring a proactive approach to urban security."
        ],
        gallery: [
            images.case6Gallery1,
            images.case6Gallery2,
            images.case6Gallery3,
            images.case6Gallery4,
            images.case6Gallery5,
            images.case6Gallery6,
        ],
        challenges: [
            "Managing large-scale surveillance across multiple locations",
            "Limited real-time monitoring for law enforcement",
            "Difficulty in tracking suspicious activities and individuals",
            "Need for high-capacity data storage and processing"
        ],
        solutions: [
            "High-definition CCTV cameras with night vision",
            "AI-driven facial and license plate recognition",
            "Real-time monitoring and automated threat alerts",
            "Cloud-based video storage with easy retrieval"
        ],
        results: [
            "Enhanced city security and public safety",
            "Faster response times for law enforcement",
            "Reduction in crime and vandalism incidents",
            "Efficient urban traffic and crowd monitoring"
        ]
    }

];

export default cases;